export default __webpack_public_path__ + "static/media/route-mobile.7d3c0a2e.PNG";